module.exports = __webpack_public_path__ + "img/brand_bottom@2x.c6b60653.png";